import React, { FC, useState } from "react";
import { Button, Popover } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { usePurchasePoDetailsModel } from "../scmPurchasePoModel";
import { Description } from "@/components/YhBox/Description";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { useScmSaleRoDetailModel } from "../../scmSaleRo/scmSaleRoModel"


export const TopButs: FC<RouterParamType> = () => {
    const { getTreeNodeName } = useScmSaleRoDetailModel();
    const { lookFormVal: { purchaseCode, status, isReplenish, supplierName, purchaseTypeCode } } = usePurchasePoDetailsModel();
    const { selectedNavId, replaceNav, findNav, getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const goBack = () => {
        if (detailsInfo.parentInfo && detailsInfo.parentInfo.selectedNavId) {
            replaceNav(selectedNavId, detailsInfo.parentInfo.selectedNavId);
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    const orderStatu: IDescription[] = [
        {
            label: "采购单",
            value: purchaseCode ?? "",
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "供应商",
            value: supplierName,
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox
            title={<>
                {orderStatu.map((item, index) => <Description key={index} {...item} />)}
            </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}